import { render, staticRenderFns } from "./ActionPremiumSales.vue?vue&type=template&id=56910224&scoped=true"
import script from "./ActionPremiumSales.vue?vue&type=script&lang=js"
export * from "./ActionPremiumSales.vue?vue&type=script&lang=js"
import style0 from "./ActionPremiumSales.vue?vue&type=style&index=0&id=56910224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56910224",
  null
  
)

export default component.exports